import { Space, Badge } from 'antd';
import { useRequest } from 'ahooks';
import { useTranslate } from '@tolgee/react';
import { getQuestionCount } from 'views/Mercado/FAQ/services';

export const MercadoNav = () => {
  const { t } = useTranslate();
  const { data } = useRequest(getQuestionCount, {
    pollingInterval: 15 * 1000,
    pollingWhenHidden: false,
  });

  return (
    <Space>
      {t('scene.workspace.title.faq')}
      <Badge style={{ background: '#17C2FF' }} count={data} overflowCount={9999} />
    </Space>
  );
};
